var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 122,
    viewBox: "0 0 1439 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1441.48 92.164C892.358 205.37 579.813 -46.8125 6.54865e-06 47.0921L1.06656e-05 3.63606e-06C1.06656e-05 3.63606e-06 1441.48 0.000129655 1441.89 0.00012969C1442.29 0.000129725 1441.48 91.7132 1441.48 92.164Z",
    fill: "#F5F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopWave);
export default __webpack_public_path__ + "static/media/top-wave.4fa5927f93475d998e3c949886441aff.svg";
export { ForwardRef as ReactComponent };